/* eslint-disable indent */
/* eslint-disable comma-dangle */
/* eslint-disable no-trailing-spaces */

type StaticImages = {
    readonly [fileName: string]: {
        uri?: string;
    };
}

const imageStaticSourcesByFileName: StaticImages = {
    '7me9PKTiESR5CWuRPTVpEv.png': { uri: '/images/7me9PKTiESR5CWuRPTVpEv.png' },
'u3FZgRyEDiiMQ3UP8tCrwV.png': { uri: '/images/u3FZgRyEDiiMQ3UP8tCrwV.png' },
've1JbVFrJG1HAxEdVSq243.png': { uri: '/images/ve1JbVFrJG1HAxEdVSq243.png' },
'uKaK8aTaYn5y6dmfWTPxAh.png': { uri: '/images/uKaK8aTaYn5y6dmfWTPxAh.png' },
'qykgAqmrJjFuFVeKbn1fjZ.png': { uri: '/images/qykgAqmrJjFuFVeKbn1fjZ.png' },
'a2z4KZ9r4PHE3Qwz13AnMf.png': { uri: '/images/a2z4KZ9r4PHE3Qwz13AnMf.png' },
'vKT4hrE4264uMrWW9DE4qm.png': { uri: '/images/vKT4hrE4264uMrWW9DE4qm.png' },
'h7e6e3yM2ZGW1PeP9AsBNb.webp': { uri: '/images/h7e6e3yM2ZGW1PeP9AsBNb.webp' },
'eNp1RVwF4FFzWECjrx6uVa.png': { uri: '/images/eNp1RVwF4FFzWECjrx6uVa.png' },
'9LFbz3Yi7mH8BC3fbHXeRF.png': { uri: '/images/9LFbz3Yi7mH8BC3fbHXeRF.png' },
'iB5rBVoeJYg8dGvKUNMck7.png': { uri: '/images/iB5rBVoeJYg8dGvKUNMck7.png' },
'cFWpwB86NjeTP22dNmTjPT.png': { uri: '/images/cFWpwB86NjeTP22dNmTjPT.png' },
'uoDvC5Z7tpZ4kieURMTm89.png': { uri: '/images/uoDvC5Z7tpZ4kieURMTm89.png' },
'ej1C7TMazWbt5VPK6DfNCS.png': { uri: '/images/ej1C7TMazWbt5VPK6DfNCS.png' },
'k99UeufwieDvj7yL8CNPhq.png': { uri: '/images/k99UeufwieDvj7yL8CNPhq.png' },
'ak1FGjEGqoJXNhFSgJDN9J.png': { uri: '/images/ak1FGjEGqoJXNhFSgJDN9J.png' },
'hXfTmdbcBkUNtgKdw2zF12.png': { uri: '/images/hXfTmdbcBkUNtgKdw2zF12.png' },
'ixBRVUXi29w1PTcyGewLPG.png': { uri: '/images/ixBRVUXi29w1PTcyGewLPG.png' },
'9PmX6PstfoqW5ffSBjnG5F.png': { uri: '/images/9PmX6PstfoqW5ffSBjnG5F.png' },
'hEVeAvdtmpVTcga9VCaD4b.png': { uri: '/images/hEVeAvdtmpVTcga9VCaD4b.png' },
'93pwD1CraRyoGAK5CnCUfM.jpg': { uri: '/images/93pwD1CraRyoGAK5CnCUfM.jpg' },
'f1WNrWGQnVSS88j77cTiRE.jpg': { uri: '/images/f1WNrWGQnVSS88j77cTiRE.jpg' },
'axg2VVsUyb3CWH5LWRsAa6.png': { uri: '/images/axg2VVsUyb3CWH5LWRsAa6.png' },
'2FznsTnJA3bDPCPg3pucxQ.jpg': { uri: '/images/2FznsTnJA3bDPCPg3pucxQ.jpg' },
'9kDqyytgmZMnUihkrVyHcQ.jpg': { uri: '/images/9kDqyytgmZMnUihkrVyHcQ.jpg' },
'7MM8EDwN2WUmvB19hLhF5t.jpg': { uri: '/images/7MM8EDwN2WUmvB19hLhF5t.jpg' },
'7CULYNSVEFPaoKRGzGomEq.jpg': { uri: '/images/7CULYNSVEFPaoKRGzGomEq.jpg' },
'1Gvs77SN8BehxAtBiChdct.png': { uri: '/images/1Gvs77SN8BehxAtBiChdct.png' },
'vojS14Jvzhco3JApGaCu4e.png': { uri: '/images/vojS14Jvzhco3JApGaCu4e.png' },
'qDSRgc86ukLviXdb9bHMEZ.png': { uri: '/images/qDSRgc86ukLviXdb9bHMEZ.png' },
'21sBNu8wvfTiD3nCf6g9Ui.png': { uri: '/images/21sBNu8wvfTiD3nCf6g9Ui.png' },
'3EXFJJuivnWnoPiBrXD8eD.png': { uri: '/images/3EXFJJuivnWnoPiBrXD8eD.png' },
'jGTAFHmJ3Y8FpBx5u2d8Gj.png': { uri: '/images/jGTAFHmJ3Y8FpBx5u2d8Gj.png' },
'i1oiDzqRD9HVfcKStMQVD9.png': { uri: '/images/i1oiDzqRD9HVfcKStMQVD9.png' },
'g4fH94Uou9YwW7ztN9qNE7.png': { uri: '/images/g4fH94Uou9YwW7ztN9qNE7.png' },
'5Z4qTRtNKF2RHEjVyN9gUT.png': { uri: '/images/5Z4qTRtNKF2RHEjVyN9gUT.png' },
'47H3W8fZmdbkB5kGEV5ucX.png': { uri: '/images/47H3W8fZmdbkB5kGEV5ucX.png' },
'3Rs3wxsdEvPmWu6yPH13jL.png': { uri: '/images/3Rs3wxsdEvPmWu6yPH13jL.png' },
'r85dxwTzbiUwA5kFrRSz3B.png': { uri: '/images/r85dxwTzbiUwA5kFrRSz3B.png' },
'9Y3Kw4pTh9YATVfkKt9N85.png': { uri: '/images/9Y3Kw4pTh9YATVfkKt9N85.png' },
'tHvQgfn4FjfjSonurt4Fqd.png': { uri: '/images/tHvQgfn4FjfjSonurt4Fqd.png' },
'2YD85Knqga2jjMweV9p6Qo.png': { uri: '/images/2YD85Knqga2jjMweV9p6Qo.png' },
'uAvjLDaQ4XbhKj8twwGP5h.png': { uri: '/images/uAvjLDaQ4XbhKj8twwGP5h.png' },
'2BzDGZqUp78crGGWUmyfwk.png': { uri: '/images/2BzDGZqUp78crGGWUmyfwk.png' },
'u9Nr8Vhpw8yh9M5MVoyMon.png': { uri: '/images/u9Nr8Vhpw8yh9M5MVoyMon.png' },
'45oL5pa5es1XMwgXxrRc1G.png': { uri: '/images/45oL5pa5es1XMwgXxrRc1G.png' },
'jTzCFRunQJPxrEQ74Nr4sH.png': { uri: '/images/jTzCFRunQJPxrEQ74Nr4sH.png' },
'pPyf5Qi24GzCYcQR7XDX9r.png': { uri: '/images/pPyf5Qi24GzCYcQR7XDX9r.png' }
}

export default imageStaticSourcesByFileName
